module.exports = "../images/lake@2x.jpg?v=f37ea0a";